<template>
  <div class="bg-white rounded-xl shadow-lg p-6 border-l-4 border-red-500">
    <div class="flex items-center gap-3 mb-4">
      <span class="text-3xl">🚨</span>
      <div>
        <h3 class="text-xl font-bold text-gray-900">Alertas Críticas</h3>
        <p class="text-sm text-gray-600">
          {{ alertas.total_alertas }} alerta{{ alertas.total_alertas !== 1 ? 's' : '' }} 
          ({{ alertas.criticas }} crítica{{ alertas.criticas !== 1 ? 's' : '' }}, {{ alertas.advertencias }} advertencia{{ alertas.advertencias !== 1 ? 's' : '' }})
        </p>
      </div>
    </div>

    <div class="space-y-3">
      <div
        v-for="(alerta, index) in alertas.alertas"
        :key="index"
        :class="[
          'p-4 rounded-lg border-l-4 transition-all hover:shadow-md',
          alerta.tipo === 'CRITICA' ? 'bg-red-50 border-red-500' : 'bg-yellow-50 border-yellow-500'
        ]"
      >
        <div class="flex items-start gap-3">
          <span class="text-2xl">{{ alerta.icono }}</span>
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <h4 class="font-semibold text-gray-900">{{ alerta.titulo }}</h4>
              <span 
                :class="[
                  'px-2 py-0.5 rounded-full text-xs font-medium',
                  alerta.tipo === 'CRITICA' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'
                ]"
              >
                {{ alerta.tipo }}
              </span>
              <span class="px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                {{ alerta.categoria }}
              </span>
            </div>
            <p class="text-sm text-gray-700 mb-2">{{ alerta.mensaje }}</p>
            <div class="flex items-center gap-2 text-sm">
              <span class="text-gray-600">⚡ Acción requerida:</span>
              <span class="font-medium text-gray-900">{{ alerta.accion_requerida }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertasCard',
  props: {
    alertas: {
      type: Object,
      required: true
    }
  }
};
</script>
